(function () {
  'use strict';

  var T = window.PoloTheme || {};

  /* ---------- Money -------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  T.formatMoney = formatMoney;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isColorOption(name) { return /colou?r|shade/i.test(name); }
  function cssColor(value) {
    var v = String(value).toLowerCase().replace(/\s+/g, '');
    var map = { 'armygreen': '#4b5320', 'navyblue': '#1f2a44', 'darkgray': '#4a4d52', 'darkgrey': '#4a4d52', 'brown': '#6b4a35', 'offwhite': '#f2efe6', 'cream': '#efe7d4', 'ecru': '#e8dfc8', 'stone': '#cbc3b1', 'sand': '#d8c6a3', 'khaki': '#b9a77f', 'olive': '#6b6b3a', 'sage': '#9caf88', 'forest': '#284634', 'forestgreen': '#284634', 'bottlegreen': '#1f3d2b', 'navy': '#1b2840', 'midnight': '#141b2d', 'charcoal': '#3a3d42', 'heathergrey': '#a9a9a6', 'heathergray': '#a9a9a6', 'burgundy': '#5e1f28', 'wine': '#5a1e2a', 'maroon': '#5a1b22', 'skyblue': '#8fb8de', 'babyblue': '#a9c9e8', 'royalblue': '#2b4fa0', 'terracotta': '#b4472f', 'rust': '#9c4a2a', 'mustard': '#c99a2e', 'pink': '#e7b8bd', 'lilac': '#bfa9cf', 'mint': '#b9dcc8' };
    if (map[v]) return map[v];
    if (window.CSS && CSS.supports && CSS.supports('color', v)) return v;
    return null;
  }

  /* ---------- Reveal on scroll -------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Buy box ------------------------------------------------ */
  function BuyBox(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-buy-form]');
    var picksEl = root.querySelector('[data-picks]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var addBtn = root.querySelector('[data-add]');
    var addPrice = root.querySelector('[data-add-price]');
    var addLabel = root.querySelector('[data-add-label]');
    var errorEl = root.querySelector('[data-error]');
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));

    var hasOptions = !(product.variants.length === 1 && product.options.length === 1 && /title/i.test(product.options[0]));
    var firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var picks = []; // array of option arrays
    var state = { qty: 1, free: 0 };

    var selected = tiers.find(function (t) { return t.classList.contains('is-selected'); }) || tiers[0];
    if (selected) { state.qty = +selected.dataset.qty; state.free = +selected.dataset.free; selected.querySelector('input').checked = true; selected.classList.add('is-selected'); }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function optionValues(i) {
      var seen = [];
      product.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
      return seen;
    }

    function syncPicks() {
      while (picks.length < state.qty) {
        picks.push((picks[picks.length - 1] || firstAvail.options).slice());
      }
      picks.length = state.qty;
    }

    function renderPicks() {
      if (!hasOptions) { picksEl.parentNode.style.display = 'none'; return; }
      var html = '';
      var paid = state.qty - state.free;
      picks.forEach(function (opts, idx) {
        var isFree = idx >= paid;
        html += '<div class="pick" data-pick="' + idx + '">';
        html += '<span class="pick__num' + (isFree ? ' is-free' : '') + '">' + (isFree ? 'FREE' : (idx + 1)) + '</span>';
        html += '<div class="pick__opts">';
        product.options.forEach(function (name, oi) {
          var vals = optionValues(oi);
          var colorable = isColorOption(name) && vals.every(function (v) { return cssColor(v); });
          if (colorable) {
            html += '<div class="swatches" role="radiogroup" aria-label="' + esc(name) + ' for polo ' + (idx + 1) + '">';
            vals.forEach(function (val) {
              html += '<button type="button" class="swatch' + (opts[oi] === val ? ' is-active' : '') + '" style="background:' + cssColor(val) + '" data-opt="' + oi + '" data-val="' + esc(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '" aria-pressed="' + (opts[oi] === val) + '"></button>';
            });
            html += '</div>';
          } else {
            html += '<div class="select-wrap"><small>' + esc(name) + '</small><select data-opt="' + oi + '" aria-label="' + esc(name) + ' for polo ' + (idx + 1) + '">';
            vals.forEach(function (val) {
              var test = opts.slice(); test[oi] = val;
              var v = findVariant(test);
              var soldOut = v && !v.available;
              html += '<option value="' + esc(val) + '"' + (opts[oi] === val ? ' selected' : '') + '>' + esc(val) + (soldOut ? ' — sold out' : '') + '</option>';
            });
            html += '</select></div>';
          }
        });
        html += '</div></div>';
      });
      picksEl.innerHTML = html;
    }

    function variantsInCart() {
      return picks.map(function (o) { return findVariant(o); });
    }

    function updatePrices() {
      var vars = variantsInCart();
      var valid = vars.every(function (v) { return v && v.available; });
      var prices = vars.map(function (v) { return v ? v.price : 0; });
      var total = prices.reduce(function (a, b) { return a + b; }, 0);
      var sorted = prices.slice().sort(function (a, b) { return a - b; });
      var discount = sorted.slice(0, state.free).reduce(function (a, b) { return a + b; }, 0);

      if (addPrice) addPrice.innerHTML = '· ' + formatMoney(total - discount) + (discount > 0 ? ' <s style="opacity:.7;font-weight:400">' + formatMoney(total) + '</s>' : '');
      if (addLabel) addLabel.textContent = state.qty > 1 ? 'Add ' + state.qty + ' to bag' : 'Add to bag';
      if (addBtn) addBtn.disabled = !valid;
      errorEl.classList.toggle('is-visible', !valid);
      errorEl.textContent = valid ? '' : 'One of your picks is sold out, choose another size or colour.';

      // Refresh tier cards using the first pick's unit price
      var unit = (vars[0] || firstAvail).price;
      tiers.forEach(function (t) {
        var q = +t.dataset.qty, f = +t.dataset.free;
        var now = t.querySelector('[data-tier-now]'), was = t.querySelector('[data-tier-was]');
        if (now) now.textContent = formatMoney(unit * (q - f));
        if (was) was.textContent = formatMoney(unit * q);
      });
      var unitEl = root.querySelector('[data-unit-price]');
      if (unitEl) unitEl.textContent = formatMoney(unit);

      // Swap gallery image to match the first pick
      var v0 = vars[0];
      if (v0 && v0.featured_image && mainImg) {
        var id = v0.featured_image.id;
        var thumb = thumbs.find(function (t) { return +t.dataset.imageId === id; });
        if (thumb) { showImage(thumb); var c = root.querySelector('.gallery__count'); if (c) c.textContent = (thumbs.indexOf(thumb) + 1) + ' / ' + thumbs.length; }
      }
    }

    function showImage(thumb) {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = thumb.dataset.src;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t); }); });

    // Swipe the main photo on touch screens + image counter
    var mainWrap = root.querySelector('.gallery__main');
    if (mainWrap && thumbs.length > 1) {
      var counter = document.createElement('span');
      counter.className = 'gallery__count';
      mainWrap.appendChild(counter);
      var updateCount = function () {
        var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        counter.textContent = (i + 1) + ' / ' + thumbs.length;
      };
      updateCount();
      thumbs.forEach(function (t) { t.addEventListener('click', updateCount); });
      var startX = null, startY = null;
      mainWrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        var next = thumbs[(i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
        showImage(next); updateCount();
        next.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
        t.querySelector('input').checked = true;
        state.qty = +t.dataset.qty; state.free = +t.dataset.free;
        syncPicks(); renderPicks(); updatePrices();
      });
    });

    picksEl.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-opt]'); if (!sel) return;
      var idx = +sel.closest('[data-pick]').dataset.pick;
      picks[idx][+sel.dataset.opt] = sel.value;
      renderPicks(); updatePrices();
    });
    picksEl.addEventListener('click', function (e) {
      var sw = e.target.closest('.swatch'); if (!sw) return;
      var idx = +sw.closest('[data-pick]').dataset.pick;
      picks[idx][+sw.dataset.opt] = sw.dataset.val;
      renderPicks(); updatePrices();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vars = variantsInCart();
      var grouped = {};
      vars.forEach(function (v) { grouped[v.id] = (grouped[v.id] || 0) + 1; });
      var items = Object.keys(grouped).map(function (id) { return { id: +id, quantity: grouped[id] }; });
      addBtn.classList.add('is-loading');
      fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          addBtn.classList.remove('is-loading');
          if (!res.ok) { errorEl.textContent = res.body.description || 'Could not add to bag.'; errorEl.classList.add('is-visible'); return; }
          Cart.open();
        })
        .catch(function () { addBtn.classList.remove('is-loading'); errorEl.textContent = 'Network error, try again.'; errorEl.classList.add('is-visible'); });
    });

    syncPicks(); renderPicks(); updatePrices();

    // Sticky mobile bar
    var sticky = root.parentNode.querySelector('[data-sticky-buy]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var r = en[0];
        sticky.classList.toggle('is-visible', !r.isIntersecting && r.boundingClientRect.top < 0);
      }).observe(form);
    }
  }

  /* ---------- Cart drawer ------------------------------------------- */
  var Cart = {
    el: null,
    init: function () {
      this.el = document.querySelector('[data-drawer]');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
        var q = e.target.closest('[data-line-qty]');
        if (q) { self.change(q.dataset.key, +q.dataset.lineQty); }
        var up = e.target.closest('[data-upsell]');
        if (up) { self.addMore(+up.dataset.variant, +up.dataset.upsell, up); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
    },
    open: function () {
      document.documentElement.classList.add('drawer-open');
      this.el.setAttribute('aria-hidden', 'false');
      this.refresh();
    },
    close: function () {
      document.documentElement.classList.remove('drawer-open');
      if (this.el) this.el.setAttribute('aria-hidden', 'true');
    },
    refresh: function () {
      var self = this;
      return fetch(T.routes.cart, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    change: function (key, qty) {
      var self = this;
      fetch(T.routes.cartChange, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); });
    },
    addMore: function (variantId, qty, btn) {
      var self = this;
      btn.classList.add('is-loading');
      fetch(T.routes.cartAdd, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      }).then(function () { self.refresh(); });
    },
    progress: function (count) {
      var tiers = (T.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      var max = tiers.length ? tiers[tiers.length - 1].qty : 1;
      var next = tiers.find(function (t) { return count < t.qty; });
      var reached = tiers.filter(function (t) { return count >= t.qty; }).pop();
      var msg;
      if (!count) msg = 'Buy ' + (tiers[0].qty - tiers[0].free) + ', get ' + tiers[0].free + ' <strong>free</strong>.';
      else if (next) {
        var need = next.qty - count;
        msg = (reached ? '<strong>' + reached.free + ' free</strong> unlocked! ' : '') + 'Add ' + need + ' more polo' + (need > 1 ? 's' : '') + ' to get <strong>' + next.free + ' free</strong>.';
      } else msg = 'Max deal unlocked: <strong>' + reached.free + ' polos free</strong> 🎉';
      var marks = tiers.map(function (t) { return '<span class="' + (count >= t.qty ? 'is-hit' : '') + '">' + t.qty + ' = ' + t.free + ' free</span>'; }).join('');
      return { html: '<p>' + msg + '</p><div class="bar"><div class="bar__fill" style="width:' + Math.min(100, (count / max) * 100) + '%"></div></div><div class="bar__marks"><span>' + '0' + '</span>' + marks + '</div>', next: next, need: next ? next.qty - count : 0 };
    },
    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.dataset.count = cart.item_count; });
      if (!this.el) return;
      var itemsEl = this.el.querySelector('[data-drawer-items]');
      var footEl = this.el.querySelector('[data-drawer-foot]');
      var progEl = this.el.querySelector('[data-drawer-progress]');
      var p = this.progress(cart.item_count);
      progEl.innerHTML = p.html;

      if (!cart.item_count) {
        itemsEl.innerHTML = '<div class="drawer__empty"><p>Your bag is empty.</p><a class="btn" href="/#buy" data-cart-close>Shop the polo</a></div>';
        footEl.hidden = true;
        return;
      }
      footEl.hidden = false;
      var html = '';
      cart.items.forEach(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var free = (it.line_level_discount_allocations || []).some(function (d) { return d.amount > 0; });
        html += '<div class="line">' +
          '<div class="line__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div><div class="line__title">' + esc(it.product_title) + '</div>' +
          (it.variant_title ? '<div class="line__variant">' + esc(it.variant_title) + '</div>' : '') +
          (free ? '<span class="line__free">' + esc(it.line_level_discount_allocations[0].discount_application.title) + '</span>' : '') +
          '<div class="qty"><button type="button" aria-label="Decrease" data-key="' + it.key + '" data-line-qty="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase" data-key="' + it.key + '" data-line-qty="' + (it.quantity + 1) + '">+</button></div></div>' +
          '<div class="line__price">' + formatMoney(it.final_line_price) + (it.final_line_price < it.original_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') + '</div>' +
          '</div>';
      });
      if (p.next && cart.items.length) {
        var last = cart.items[cart.items.length - 1];
        html += '<div class="upsell"><span>Add <strong>' + p.need + '</strong> more and get <strong style="color:var(--deal)">' + p.next.free + ' free</strong></span><button type="button" class="btn btn--deal" data-upsell="' + p.need + '" data-variant="' + last.variant_id + '">Add ' + p.need + '</button></div>';
      }
      itemsEl.innerHTML = html;

      var saved = cart.original_total_price - cart.total_price;
      footEl.innerHTML =
        '<div class="drawer__row"><span>Subtotal</span><span>' + formatMoney(cart.original_total_price) + '</span></div>' +
        (saved > 0 ? '<div class="drawer__row drawer__row--save"><span>Bundle savings</span><span>−' + formatMoney(saved) + '</span></div>' : '') +
        '<div class="drawer__row drawer__row--total"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn btn--block">Checkout</a>' +
        '<p class="drawer__small">Shipping & taxes calculated at checkout</p>';
    }
  };
  T.Cart = Cart;

  /* ---------- Header menu ------------------------------------------- */
  function initMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Cart.init();
    initMenu();
    initReveal();
    document.querySelectorAll('[data-buybox]').forEach(function (el) { BuyBox(el); });
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-buybox]').forEach(function (el) { BuyBox(el); });
    initReveal();
  });
})();
